import React from "react";
import {OuterTabsProps} from "./OuterTabs.props";
import {OuterTabsStyles} from "./OuterTabs.styles";

export const OuterTabs = ({...props}: OuterTabsProps): React.ReactElement => {
  return (
    <OuterTabsStyles defaultActiveKey="1" items={props.items} {...props} animated={{inkBar: false}}/>
  )
}